import React, { useState } from "react";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

import DocumentPreviewModal from "../DocumentPreviewModal";
import Collapse from "./Collapse";

import { getImageUrl } from "utils";
import getFileExtension from "utils/getFileExtension";
import removeExtension from "utils/removeExtension";
import downloadFile from "utils/downloadFile";

const docFormats = ["doc", "docx"];

const DocumentsView = ({
  documents,
  isExpandable = true,
  isDcsUtility = false,
  t,
}) => {
  const [documentToPreview, setDocumentToPreview] = useState();

  const processedDocuments = isDcsUtility
    ? documents?.filter((doc) => doc.id)
    : documents;
    
  const downloadBtnHandler = (name, documentTypeName, documentURL) => {
    const fileExtension = getFileExtension(name ?? "");
    const url = getImageUrl(documentURL ?? "");

    if (docFormats.includes(fileExtension.toLowerCase())) {
      downloadFile(url, `${documentTypeName}.${fileExtension}`);
      toast.success("Document downloaded successfully");
    } else {
      setDocumentToPreview({
        documentTypeName,
        url,
        documentType: fileExtension,
        documentName: removeExtension(name ?? ""),
      });
    }
  };

  return (
    <>
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          {...documentToPreview}
        />
      )}
      <Collapse title="Documents" isExpandable={isExpandable}>
        <Row className="d-flex w-100 mb-2 ">
          {processedDocuments
            ? processedDocuments?.map(
                (
                  {
                    id,
                    name,
                    documentTypeName,
                    documentURL,
                    documentCategoryDescription,
                    documentTypeDescription,
                  },
                  index
                ) => {
                  return (
                    <Col lg={12} className="mb-1" key={index}>
                      <Row className="mb-2">
                        <Col lg={10}>
                          {documentCategoryDescription
                            ? `${documentCategoryDescription} - ${documentTypeDescription}`
                            : documentTypeDescription}
                        </Col>
                        <Col lg={2} className="fw-semibold">
                          <Button
                            onClick={() =>
                              downloadBtnHandler(
                                name,
                                documentTypeName,
                                documentURL
                              )
                            }
                            disabled={!id}
                            variant="outlined"
                            size="small"
                          >
                            {t("View")}
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  );
                }
              )
            : null}
        </Row>
      </Collapse>
    </>
  );
};

DocumentsView.propTypes = {
  documents: PropTypes.array,
  isExpandable: PropTypes.bool,
  isDcsUtility: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(DocumentsView);
